import req from "./request";

export default {
  index: async () => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;

      let url = `contracts?building_id=${building.id}`;
      const { data } = await req.get(url, true);
      return data;
    } catch (error) {
      throw error;
    }
  },
  show: async (id) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;

      const { data } = await req.get(
        `contracts/${id}?building_id=${building.id}`,
        true
      );
      return data;
    } catch (error) {
      throw error;
    }
  },
  store: async (data) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      const response = await req.post(
        `contracts?building_id=${building.id}`,
        data,
        true
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  storeDocuments: async (id, data) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      let url = `contracts/${id}/documents?building_id=${building.id}}`;
      return await req.post(url, data, true);
    } catch (error) {
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      let url = `contracts/${id}?building_id=${building.id}`;

      const response = await req.put(url, data, true);
      return response;
    } catch (error) {
      throw error;
    }
  },
  destroy: async (id) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      let url = `contracts/${id}?building_id=${building.id}`;

      const response = await req.delete(url, true);
      return response;
    } catch (error) {
      throw error;
    }
  },
  download: async () => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      let url = `contracts/documents?building_id=${building.id}`;
      return await req.get(url, true);
    } catch (error) {
      throw error;
    }
  },
  downloadSingle: async (id) => {
    try {
      const building = JSON.parse(localStorage.getItem("building")) || null;
      let url = `contracts/${id}/documents/?building_id=${building.id}`;

      return await req.get(url, true);
    } catch (error) {
      throw error;
    }
  },
};
